import neos, {NeosContext, NeosInjectedProps} from '@neos-project/neos-ui-decorators/src/neos';

export {
    neos,
    NeosContext,
    NeosInjectedProps
};
